module.exports = __webpack_public_path__ + "img/icon_pj_dy.31c81002.png";